import * as React from "react";
import {navigateTo} from 'gatsby-link';
import HeaderMegamenuDropdownItemMenuElement from "./header-megamenu-dropdown-item-menu-element";
import styled from "styled-components";

interface HeaderMegamenuDropdownProps {
  /** TEKST GŁÓWNEGO PRZYCISKU */
  dropdownName: string

  /** LINK GŁÓWNEGO PRZYCISKU */
  dropdownLink?: string

  /** OTWIERANIE W NOWYM OKNIE */
  dropdownLinkOpenInNewTab?: boolean

  /** WYSUWANE ELEMENTY DROPDOWNA */
  dropdownElements: HeaderMegamenuDropdownItemMenuElementData[]
}

interface HeaderMegamenuDropdownState {
  active: boolean
}

class HeaderMegamenuDropdown extends React.Component<HeaderMegamenuDropdownProps,HeaderMegamenuDropdownState> {

  constructor(props: HeaderMegamenuDropdownProps) {
    super(props);
    this.state = {
      active: false
    };
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.handleHeaderMenuElementSelection = this.handleHeaderMenuElementSelection.bind(this);
  }

  onMouseEnter() {
    this.setState({active: true});
  }

  onMouseLeave() {
    this.setState({active: false});
  }

  handleHeaderMenuElementSelection(dropdownLink: string) {
    this.setState({active: false});
    navigateTo(dropdownLink);
  }

  render() {
    const {dropdownName,dropdownLink,dropdownLinkOpenInNewTab,dropdownElements} = this.props;
    const {active} = this.state;

    // COMPONENT VARIABLES
    const hasChildren: boolean = dropdownElements && dropdownElements.length > 0;

    return (
      <MenuListElementWrapper onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
        {/* PRZENOSZENIE DO LINKÓW Z NASZEJ DOMENY => NIE W OKNIE NOWYM */}
        {!dropdownLinkOpenInNewTab &&
          <a onClick={() => dropdownLink && this.handleHeaderMenuElementSelection(dropdownLink)}>
            {dropdownName}
            {hasChildren && <span className="indicator"><i className="fa fa-angle-down"></i></span>}
          </a>
        }

        {/* PRZENOSZENIE DO OBCYCH LINKÓW => POZA DOMENĄ => W NOWYM OKNIE */}
        {dropdownLink && dropdownLinkOpenInNewTab &&
          <a href={dropdownLink} target="_blank" rel="nofollow">
            {dropdownName}
            {hasChildren && <span className="indicator"><i className="fa fa-angle-down"></i></span>}
          </a>
        }
        <ul className="dropdown" style={active ? ActiveStyle : InactiveStyle}>
          <HeaderMegamenuDropdownItemMenuElement
            elements={dropdownElements}
            handleHeaderMenuElementSelection={this.handleHeaderMenuElementSelection}
          />
        </ul>
      </MenuListElementWrapper>
    )
  }

}

/** STYLES */

const MenuListElementWrapper = styled.li`
  @media (max-width: 1080px) {
    a {
      font-size: 13px !important;
    }
  }
  @media (max-width: 1280px) {
    a {
      font-size: 14px !important;
    }
  }
`;

export const ActiveStyle: React.CSSProperties = {
  right: 'auto',
  display: 'block'
};

export const InactiveStyle: React.CSSProperties = {};

export default HeaderMegamenuDropdown


// WEBPACK FOOTER //
// ./src/layouts/header/header-megamenu-dropdown.tsx